export const bannerQuestions = [{
        additionalClass: "",
        fields: [{
            label: "Short introduction",
            name: "shortIntro",
            type: "text",
            placeholder: "A sentence introducing yourself to potential employers.",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Long introduction",
            name: "longIntro",
            type: "textarea",
            placeholder: "List your passions, strengths, extracurricular activities, favourite subjects at school, any previous work experience or career education that is relevant and the careers you’re interested in learning more about.",
            maxlength: 1500,
            required: true,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "List of personal qualities",
            name: "qualitiesList",
            note: "Limit: 5 qualities",
            type: "itemadder",
            placeholder: "eg neat, organised, respectful, responsible, creative",
            required: false,
            maxlength: 15,
            maxnumber: 5,
            display: "tags",
            suggestions: [
                "Friendly",
                "Creative",
                "Confident",
                "Artistic",
                "Quiet",
                "Hard-working",
                "Enthusiastic",
                "Reliable",
                "Responsible",
                "Adaptable",
                "Considerate",
                "Proactive",
                "Respectful",
                "Focused",
                "Thinker",
                "Hands-on",
                "Patient"
            ]
        }]
    }
]

export const skillsQuestions = [{
    additionalClass: "",
    fields: [{
        label: "Skills",
        name: "skillsList",
        note: "Limit: 10 skills",
        type: "itemadder",
        placeholder: "eg teamwork, communication, fluent in Mandarin, problem-solving, IT skills, customer service, attention to detail, time management",
        required: true,
        maxlength: 50,
        maxnumber: 10,
        display: "tags",
        suggestions: [
            "Creativity",
            "Communication skills",
            "Teamwork",
            "Self-motivated",
            "Leadership",
            "IT skills",
            "Time management",
            "Problem solving",
            "Decision making",
            "Interpersonal skills",
            "Customer service",
            "Research and analysis",
            "Machinery skills",
            "Respect"
        ]
    }]
}]

export const extraCurricularQuestions = [{
    additionalClass: "",
    fields: [{
        label: "Extra curricular activities",
        name: "extraCurricularList",
        note: "Limit: 10 activities",
        type: "itemadder",
        placeholder: "List 1 at a time eg: student representative council or debate team",
        required: true,
        maxlength: 100,
        maxnumber: 10,
        display: "unordered"
    }]
}]

export const qualificationsQuestions = [{
        additionalClass: "",
        fields: [{
            label: "Title of qualification or licence",
            name: "achieveTitle",
            type: "text",
            placeholder: "eg First Aid",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Description, date issued, expiry",
            name: "achieveDescription",
            type: "text",
            placeholder: "eg DHS, Sept 2019 (Exp Sept 2022)",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Achievement type",
            name: "achieveType",
            type: "radio",
            required: true,
            options: [
                "Qualification",
                "Licence",
                "Award"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Supporting document",
            note: "Do not upload any documents that can be used as personal identification, such as a driver’s licence. These qualifications may be listed but should not be uploaded.",
            name: "achieveFile",
            type: "fileupload",
            placeholder: "eg 1234, url",
            required: false,
            maxlength: 10,
            // additionalQuestionClass: "hidden"
        }]
    }
]

export const awardsQuestions = [{
        additionalClass: "",
        fields: [{
            label: "Award title",
            name: "achieveTitle",
            type: "text",
            placeholder: "eg Mathematics Academic Achievement Award",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Description, issuer, organisation",
            name: "achieveDescription",
            type: "text",
            placeholder: "eg Year 11 – South Australia High School",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Achievement type",
            name: "achieveType",
            type: "radio",
            required: true,
            options: [
                "Qualification",
                "Licence",
                "Award"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Supporting document",
            name: "achieveFile",
            type: "fileupload",
            placeholder: "eg 1234, url",
            required: false,
            maxlength: 10,
            // additionalQuestionClass: "hidden"
        }]
    }
]

export const experienceQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of work experience did you do?",
            name: "expType",
            type: "radio",
            required: true,
            options: [
                "Work experience",
                "Volunteering",
                "Extra-curricular",
                "Employment"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Name of company, organisation or event",
            name: "expOrg",
            type: "text",
            placeholder: "eg Bobs burgers",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",
            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: false,
                value: "2021-07-22T08:55:59Z",
                default: ''
            },
            {
                label: "In progress?",
                name: "expPresent",
                type: "checkbox",
                required: false,
                options: [
                    "Yes"
                ],
            }
        ]
    },
    {
        additionalClass: "",
        fields: [{
            label: "List of responsibilities",
            name: "expResponsibilities",
            note: "Limit: 5 bullet points",
            type: "itemadder",
            placeholder: "List up to 5 eg support mechanic, help change tyres, store tools, read engine diagnostics data",
            required: true,
            maxlength: 100,
            maxnumber: 5,
            display: "unordered"
        }]
    }
]

export const employmentQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of work experience did you do?",
            name: "expType",
            type: "radio",
            required: true,
            options: [
                "Work experience",
                "Volunteering",
                "Extra-curricular",
                "Employment"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Name of company, organisation or event",
            name: "expOrg",
            type: "text",
            placeholder: "eg Local Supermarket",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Job title",
            name: "expTitle",
            type: "text",
            placeholder: "eg Customer Service team member",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",
            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: false,
                value: "2021-07-22T08:55:59Z",
                default: ''
            },
            {
                label: "In progress?",
                name: "expPresent",
                type: "checkbox",
                required: false,
                options: [
                    "Yes"
                ],
            }
        ]
    },
    {
        additionalClass: "",
        fields: [{
            label: "List of responsibilities",
            name: "expResponsibilities",
            note: "Limit: 5 bullet points",
            type: "itemadder",
            placeholder: "List up to 5 eg serve customers, stock shelves, open store, stocktake",
            required: true,
            maxlength: 100,
            maxnumber: 5,
            display: "unordered"
        }]
    }
]

export const workExperienceQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of work experience did you do?",
            name: "expType",
            type: "radio",
            required: true,
            options: [
                "Work experience",
                "Volunteering",
                "Extra-curricular",
                "Employment"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Name of company, organisation or event",
            name: "expOrg",
            type: "text",
            placeholder: "eg Southside Automotive",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Job title",
            name: "expTitle",
            type: "text",
            placeholder: "eg automotive mechanic",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",
            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: false,
                value: "2021-07-22T08:55:59Z",
                default: ''
            },
            {
                label: "In progress?",
                name: "expPresent",
                type: "checkbox",
                required: false,
                options: [
                    "Yes"
                ],
            }
        ]
    },
    {
        additionalClass: "",
        fields: [{
            label: "List of responsibilities",
            name: "expResponsibilities",
            note: "Limit: 5 bullet points",
            type: "itemadder",
            placeholder: "List up to 5 eg support mechanic, help change tyres, store tools, read engine diagnostics data",
            required: true,
            maxlength: 100,
            maxnumber: 5,
            display: "unordered"
        }]
    }
]

export const volunteeringQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of work experience did you do?",
            name: "expType",
            type: "radio",
            required: true,
            options: [
                "Work experience",
                "Volunteering",
                "Extra-curricular",
                "Employment"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Name of company, organisation or event",
            name: "expOrg",
            type: "text",
            placeholder: "eg Great and Small Animal Rescue",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Volunteer role",
            name: "expTitle",
            type: "text",
            placeholder: "eg animal attendant",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",
            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: false,
                value: "2021-07-22T08:55:59Z",
                default: ''
            },
            {
                label: "In progress?",
                name: "expPresent",
                type: "checkbox",
                required: false,
                options: [
                    "Yes"
                ],
            }
        ]
    },
    {
        additionalClass: "",
        fields: [{
            label: "List of responsibilities",
            name: "expResponsibilities",
            note: "Limit: 5 bullet points",
            type: "itemadder",
            placeholder: "List up to 5 eg clean animal enclosures, complete animal journals, feed animals",
            required: true,
            maxlength: 100,
            maxnumber: 5,
            display: "unordered"
        }]
    }
]

export const educationQuestions = [{
        additionalClass: "",
        fields: [{
            label: "Description (eg high school, Certificate II in Community Services)",
            name: "acaTitle",
            type: "text",
            placeholder: "eg Year 12 or Certificate II in Engineering",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "School/Training Provider",
            name: "acaInstitution",
            type: "text",
            placeholder: "eg Your school or training provider",
            required: true,
            maxlength: 100
        }]
    },
    {
        additionalClass: "group-row",
        fields: [{
                label: "Start date",
                name: "startDate",
                type: "date",
                required: true,
                value: "2021-05-05T08:55:59Z",
            },
            {
                label: "End date",
                name: "endDate",
                type: "date",
                required: false,
                value: "2021-07-22T08:55:59Z"
            },
            {
                label: "In progress?",
                name: "acaPresent",
                type: "checkbox",
                required: false,
                options: [
                    "Yes"
                ],
            }
        ]
    }
]

export const refereeQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of supplement data is this?",
            name: "supType",
            type: "radio",
            required: true,
            options: [
                "Referee",
                "Portfolio"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Full name",
            name: "supTitle",
            type: "text",
            placeholder: "eg Bob Boblaw",
            required: true,
            maxlength: 100,
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Job title/Description",
            name: "supInfo",
            type: "text",
            placeholder: "eg Solicitor and CEO of Bob Boblaws Law blog",
            maxlength: 100,
            required: false,
        }]
    },
]

export const portfolioQuestions = [{
        additionalClass: "",
        fields: [{
            label: "What type of supplement data is this?",
            name: "supType",
            type: "radio",
            required: true,
            options: [
                "Referee",
                "Portfolio"
            ],
            additionalQuestionClass: "hidden"
        }]
    },
    {
        additionalClass: "",
        fields: [{
            label: "Display name",
            note: "This is what will be displayed on your CV eg Media production portfolio",
            name: "supInfo",
            type: "text",
            placeholder: "eg My website",
            maxlength: 100,
            required: true,
        }]
    },
    {
        additionalClass: "url-or-doc",
        additionalHeader: "Add a URL or upload a document",
        fields: [{
                label: "URL",
                name: "supTitle",
                conditionalhide: "supFile",
                type: "text",
                placeholder: "eg https://website.com/my-media-production",
                required: false,
                maxlength: 100,
            },
            {
                label: "Supporting document",
                name: "supFile",
                conditionalhide: "supTitle",
                type: "fileupload",
                placeholder: "eg 1234, url",
                required: false,
                maxlength: 10,
            }
        ]
    }
]

export const testListData = [

]